import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";

const TSnackBar = (props) => {
    const { open, message, classes, className, variant, autoCloseTime, onClose, ...other } = props;

    React.useEffect(() => {
        if (open && autoCloseTime) {
            setTimeout(() => {
                onClose();
            }, autoCloseTime);
        }
    }, [open, autoCloseTime, onClose]);

    const handleClose = (value) => () => {
        onClose(value);
    };

    const renderActions = () => {
        let actionButtons = [];

        for (let i = 0; i <= props.actions.length - 1; i++) {
            switch (props.actions[i]) {
                case "mrClose":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrClose")}
                        >
                            Close
                        </Button>
                    );
                    break;

                case "mrOK":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrOK")}
                        >
                            OK
                        </Button>
                    );
                    break;

                case "mrCancel":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrCancel")}
                        >
                            Cancel
                        </Button>
                    );
                    break;

                case "mrYes":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrYes")}
                        >
                            Yes
                        </Button>
                    );
                    break;

                case "mrNo":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrNo")}
                        >
                            No
                        </Button>
                    );
                    break;

                case "mrStayConnected":
                    actionButtons.push(
                        <Button
                            color={"inherit"}
                            key={"Action" + i}
                            onClick={handleClose("mrStayConnected")}
                        >
                            Stay Connected
                        </Button>
                    );
                    break;

                case "mrLogOff":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrLogOff")}
                        >
                            Log Off
                        </Button>
                    );
                    break;

                case "mrDismiss":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrDismiss")}
                        >
                            Dismiss
                        </Button>
                    );
                    break;

                case "mrConnect":
                    actionButtons.push(
                        <Button
                            color="inherit"
                            key={"Action" + i}
                            onClick={handleClose("mrConnect")}
                        >
                            Connect
                        </Button>
                    );
                    break;

                default:
                    break;
            }
        }

        return actionButtons;
    };

    const MyIcon = null;

    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
            open={open}
        >
            <SnackbarContent
                className={`${classes[variant]}, ${className}`}
                aria-describedby="client-snackbar"
                message={
                    <span
                        id="client-snackbar"
                        className={classes.message}
                    >
                        {MyIcon}
                        {message}
                    </span>
                }
                action={renderActions()}
                {...other}
            />
        </Snackbar>
    );
};

TSnackBar.propTypes = {
    open: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.string),
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired,
    autoCloseTime: PropTypes.number,
};

TSnackBar.defaultProps = {
    open: true,
    actions: ["mrOK"],
    classes: {},
    className: "",
    message: "Message",
    onClose: (value) => console.log("TSnackBar onClose"),
    variant: "success",
    autoCloseTime: undefined,
};

export default TSnackBar;
